import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private commonService: CommonService,private router : Router, private authService:AuthService) { }

  ngOnInit() {
    if(this.authService.isAuthenticated()){
    }
  }

	// logout profile
	logout = function (id) {

    
   localStorage.removeItem('refresh')

		this.authService.logout().subscribe(data => {
			if (data.success) {
        
      // window.localStorage.clear();
       //this link is use 
        this.routerLink="/login";
     // this.router.navigate(['/login']);
     //window.location.replace('/login')
     //window.location.reload();
        //this link use after login refesh page
      //  window.location.href = '/';
			}
			else {
        
        //window.location.href = '/login';
        //this.router.navigate(['login']);
        
			}
		});
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/header/header.component.ts